import ApiService from '@/services/api.service'

const RegionService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/Regions/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,                
            }
          }       
          return ApiService.customRequest(requestData);
    },  
    getRegions(parameter){
         const requestData = {
            method: 'get',
            url: "/Regions/",       
            params: {
                 CountryRecId:parameter.CountryRecId         
            }
          }       
          return ApiService.customRequest(requestData);
    },
    
    Add(data){
        return ApiService.post(`/Regions`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/Regions/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/Regions/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/Regions/${Id}`);
    }
  }


  
  export default RegionService;